import surveys from "@/urls/roles/admin";
import {
  sendGetRequest, sendDeleteRequest
} from "@/helper/requests";

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
  //ATTEMPT
  loadAttemptList: ({commit}, {url,finalizer, catcher}) => {
    /**
     * Загружает список всех попыток прохождения опросов
     * @param {Function} context.commit - Функция для вызова мутаций
     * @param {string} url - URL для запроса
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    if (!url) url = surveys.ADMIN.ATTEMPTS.LIST()
    sendGetRequest(
      url,
      (data) => finalizer(data, url),
      catcher
    )
  },
  loadAttemptDetail: ({commit}, {id, finalizer, catcher}) => {
    /**
     * Загружает детальную информацию о конкретной попытке
     * @param {Object} context - Контекст Vuex
     * @param {Function} commit - Функция для вызова мутаций
     * @param {number} id - Идентификатор попытки
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    let url = surveys.ADMIN.ATTEMPTS.DETAIL(id);
    sendGetRequest(
      url,
      finalizer,
      catcher
    )
  },
  loadAttemptStageList: ({commit}, {id, finalizer, catcher}) => {
    /**
     * Загружает список этапов для конкретной попытки
     * @param {Function} commit - Функция для вызова мутаций
     * @param {number} id - Идентификатор попытки
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    let url = surveys.ADMIN.ATTEMPTS.STAGES.LIST(id);
    sendGetRequest(
      url,
      finalizer,
      catcher
    )
  },
  loadAttemptStageFieldList: ({commit}, {id, stage_id, finalizer, catcher}) => {
    /**
     * Загружает поля конкретного этапа попытки
     * @param {Function} commit - Функция для вызова мутаций
     * @param {number} id - Идентификатор попытки
     * @param {number} stage_id - Идентификатор этапа
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    let url = surveys.ADMIN.ATTEMPTS.STAGES.FIELDS(id, stage_id);
    sendGetRequest(
      url,
      finalizer,
      catcher
    )
  },
  deleteAttempt: ({commit}, {id, finalizer, catcher}) => {
    /**
     * Удаляет попытку прохождения опроса
     * @param {Function} commit - Функция для вызова мутаций
     * @param {number} id - Идентификатор попытки для удаления
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    let url = surveys.ADMIN.ATTEMPTS.DELETE(id)
    sendDeleteRequest(url, finalizer, catcher)
  },
}


export default {
  namespaced: false,
  state,
  mutations,
  actions,
  getters
}
